import SoftBox from "components/SoftBox"
import SoftTypography from "components/SoftTypography"
import SoftInput from "components/SoftInput"
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import "./add-products.css"
import Checkbox from '@mui/material/Checkbox';
import CloseIcon from '@mui/icons-material/Close';
import { useState } from "react";
import Button from '@mui/material/Button';
import SoftButton from "components/SoftButton"
export const AddProducts = () => {
    const products = [
        { label: 'The Shawshank Redemption', year: 1994 },
        { label: 'The Godfather', year: 1972 },
        { label: 'The Godfather: Part II', year: 1974 },
        { label: 'The Dark Knight', year: 2008 },
        { label: '12 Angry Men', year: 1957 },
        { label: "Schindler's List", year: 1993 },
        { label: 'Pulp Fiction', year: 1994 },
    ]

    const [inputlist,setInputlist] = useState([{
        item:'',
        spec:'',
        quantity:'',
        price:''
    }]);
    
    const handleChange = (e,index)=>{
        const {name,value} = e.target;
        const list = [...inputlist]
        list[index][name] = value;
        setInputlist(list)
    }
    
    const handleClick = ()=>{
        setInputlist([...inputlist,{item:'',spec:'',quantity:'',price:''}])
    }
    
    const handleRemove = index =>{
            const list = [...inputlist];
            list.splice(index,1);
            setInputlist(list)
    }
}